export default function isComponentMounted(ref) {
  const { courseId } = ref.props.relay.variables;
  return window.location.href.includes(`courses/${courseId}/card`);
}
